// @ts-nocheck
import { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import Chart from 'react-apexcharts'
import { useQuery } from '@apollo/client'
import { CubeLoader } from '@/components/ui/cube-loader'
import { useChart } from '@/utils/chart-hook'
import { GET_SENTIMENT_BY_PERIOD } from '@/graphql/publisher-dashboard-queries'
import _ from 'lodash'

const capitaliseFirstLetter = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : '')

const PERIODS = [
    { key: 'week', label: 'This Week' },
    { key: 'month', label: 'This Month' },
    { key: 'year', label: 'This Year' },
]

const SentimentAnalysisChart = ({ name }) => {
    const { id } = useParams()
    const campaign = useQuery(GET_SENTIMENT_BY_PERIOD, {
        variables: id ? { where: { id } } : {},
    })
    const [data, setData] = useState(null)

    const { series, options, currentPeriod, changePeriod, setSeries } = useChart('line', data, [
        'sentimentThisWeek',
        'sentimentThisMonth',
        'sentimentThisYear',
    ])

    const prepareDataItem = useCallback((data, index) => {
        const names = Object.keys(data[0]).slice(1)
        return {
            name: capitaliseFirstLetter(names[index]),
            data: _.map(data, (item) => item[names[index]]),
        }
    }, [])

    const prepareData = useCallback(
        (data) => _.map([0, 1, 2], (index) => prepareDataItem(data, index)),
        [prepareDataItem],
    )

    useEffect(() => {
        if (campaign?.data?.campaigns?.[0]?.sentimentThisWeek) {
            const sentiment = campaign.data.campaigns[0]
            const value = {
                sentimentThisWeek: prepareData(sentiment.sentimentThisWeek),
                sentimentThisMonth: prepareData(sentiment.sentimentThisMonth),
                sentimentThisYear: prepareData(sentiment.sentimentThisYear),
            }
            setData(value)
            setSeries(value.sentimentThisWeek)
        }
    }, [campaign, prepareData, setSeries])

    if (!data) return <div className="tw:col-span-7"><CubeLoader size="sm" /></div>

    return (
        <div className="col-md-12 col-xl-7">
            <div className="card" data-aos="fade-up" data-aos-delay="1000">
                <div className="card-header d-flex justify-content-between flex-wrap">
                    <div className="header-title">
                        <h6 className="card-title">{name}</h6>
                    </div>
                    <div className="tw:relative tw:group">
                        <button className="tw:text-sm tw:text-blue-300 tw:bg-transparent tw:border-0 tw:cursor-pointer tw:flex tw:items-center tw:gap-1">
                            {currentPeriod}
                        </button>
                        <div className="tw:absolute tw:right-0 tw:top-full tw:mt-1 tw:bg-[#0a1929] tw:border tw:border-[#1e3a5f] tw:rounded tw:shadow-lg tw:z-50 tw:min-w-32 tw:hidden group-hover:tw:block">
                            {PERIODS.map(({ key, label }) => (
                                <button
                                    key={key}
                                    onClick={() => changePeriod(key)}
                                    className="tw:flex tw:w-full tw:px-3 tw:py-2 tw:text-sm tw:text-white tw:bg-transparent tw:border-0 hover:tw:bg-[#1e3a5f] tw:cursor-pointer"
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <Chart className="d-activity" options={options} series={series} type="line" height="300" />
                </div>
            </div>
        </div>
    )
}

export default SentimentAnalysisChart
